module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/28/assets/images/e757ea6c9112bd8d06c05e963de9fb74.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_move-vertical.svg
// module id = qn+m
// module chunks = 0